import * as Yup from 'yup'

export enum ACTIVE_TAB {
  ALL = 'all'
}
export enum REJECT_FORM_FIELDS {
  REJECTION_REASON = 'rejectionReason'
}

export interface RejectForm {
  [REJECT_FORM_FIELDS.REJECTION_REASON]: string;
}

export const validationSchema = Yup.object().shape({
  [REJECT_FORM_FIELDS.REJECTION_REASON]: Yup.string()
    .required('Rejection reason is required')
    .max(100, 'Reason must be less than 100 characters')
})
